import React from "react";
import Screen from "../../components/Screen/ScreeSplit";
import { LanguageContext } from "../../context/LanguageContext.jsx";
import { useContext } from "react";
import { Outlet } from "react-router-dom";
import { useAuth } from "../../context/LoginContext";
// import useFetch from "../../hook/useFetch";

export default function ScreenMain() {
  const { language } = useContext(LanguageContext);
  const { user } = useAuth();
  return (
    <>
      <Screen language={language} user={user} />
      <Outlet />
    </>
  );
}
